export default __webpack_public_path__ + "imgs/congratulations.png";